import { useState, useEffect, useCallback } from 'react'
import { listChannels } from '../api/client'
import type { ChannelConfig } from '../types'

interface UseChannelsResult {
  channels: ChannelConfig[]
  loading: boolean
  error: string | null
  refresh: () => void
}

export function useChannels(sessionToken: string | null): UseChannelsResult {
  const [channels, setChannels] = useState<ChannelConfig[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetch = useCallback(async () => {
    if (!sessionToken) return
    setLoading(true)
    setError(null)
    try {
      const data = await listChannels(sessionToken)
      setChannels(data)
    } catch {
      setError('Failed to load channels. Please refresh.')
    } finally {
      setLoading(false)
    }
  }, [sessionToken])

  useEffect(() => { fetch() }, [fetch])

  return { channels, loading, error, refresh: fetch }
}
